module.exports = __webpack_public_path__ + "static/media/MossyOak-Properties.458fbbde.png";